export default __webpack_public_path__ + "static/media/Group_7452.ba7cb623.png";